/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StaffShift {
    DAY = 'day',
    EVENING = 'evening',
    NIGHT = 'night',
    OPERATOR = 'operator',
}
